module.exports = __webpack_public_path__ + "static/Hoichoi-88c67afd582a1a28e3347cf2a1ae818d.png";